import axios, { POST } from './axiosConfig'

/**
 * Fetches a fresh Coveo Commerce search token from the backend.
 * Called by the Coveo SDK when the current token expires.
 *
 * @returns {Promise<string>} A valid Coveo access token
 * Error handling is done in the SDK, which will retry on failure
 */
export const getCoveoCommerceToken = async () => {
  try {
    const { data } = await axios({
      method: POST,
      url: '/insightweb/coveo-token',
      headers: { 'Content-Type': 'application/json' },
    })
    return data?.token
  } catch (error) {
    console.warn('Error fetching Coveo Commerce token: ', error)
    throw error
  }
}

/**
 * Fetches a fresh Coveo Classic search token from the backend.
 * Called by the Coveo SDK when the current token expires.
 *
 * @returns {Promise<string>} A valid Coveo access token
 * Error handling is done in the SDK, which will retry on failure
 */
export const getCoveoClassicToken = async () => {
  try {
    const { data } = await axios({
      method: POST,
      url: '/insightweb/coveo-classic-token',
      headers: { 'Content-Type': 'application/json' },
    })
    return data?.token
  } catch (error) {
    console.warn('Error fetching Coveo Classic token: ', error)
    throw error
  }
}
